import React from 'react';
import { ModalComponent } from 'components';
import { UserQuery } from 'queries';

interface Props {
  id: number;
  onClose: () => void;
}

function UserMemoModal({ id, onClose }: Props) {
  const { data } = UserQuery.useGet(String(id), id !== -1);

  if (!data) return null;

  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal
          title={`${data.name} 님의 메모`}
          handleClose={onClose}
          footer={<></>}
        >
          <p>{data.memo}</p>
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default UserMemoModal;
